// src/services/collegeloadapi.js

import axios from "axios";

/* ======================================================
   BASE URL — MUST END WITH /api/v1
====================================================== */
let BASE = process.env.REACT_APP_BACKEND_URL || "http://localhost:5001";

BASE = BASE.replace(/\/+$/, "");

if (!BASE.endsWith("/api/v1")) {
  if (BASE.endsWith("/api")) BASE = BASE + "/v1";
  else BASE = BASE + "/api/v1";
}

const API_BASE_URL = BASE;

/* ======================================================
   AXIOS INSTANCE
====================================================== */
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

/* ======================================================
   ATTACH ADMIN TOKEN (Admin Only APIs)
====================================================== */
apiClient.interceptors.request.use(
  (config) => {
    const adminToken = localStorage.getItem("adminToken");
    if (adminToken) config.headers.Authorization = `Bearer ${adminToken}`;
    return config;
  },
  (error) => Promise.reject(error)
);

/* ======================================================
   PUBLIC — TOP UNIVERSITIES
====================================================== */

// GET Active universities for homepage
export const getTopUniversities = async () => {
  return (await apiClient.get("/top-universities")).data;
};

/* ======================================================
   PUBLIC — QUICK LINKS
   (Homepage uses this)
====================================================== */

export const getQuickLinksPublic = async () => {
  try {
    // If public route exists (recommended)
    return (await apiClient.get("/public/quick-links")).data.data;
  } catch (err) {
    console.warn("Public quick-links missing → using admin fallback");

    try {
      // Fallback: Backend returns { success, data }
      return (await axios.get(API_BASE_URL + "/admin/quick-links")).data.data;
    } catch (fallbackErr) {
      console.error("Admin quick-links protected → no access");
      return [];
    }
  }
};

/* ======================================================
   ADMIN — TOP UNIVERSITIES
====================================================== */

// GET all (active + inactive)
export const getAllTopUniversitiesAdmin = async () => {
  return (await apiClient.get("/top-universities/admin/all")).data;
};

// CREATE
export const createTopUniversity = async (formData) => {
  return (
    await apiClient.post("/top-universities", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
  ).data;
};

// UPDATE
export const updateTopUniversity = async (id, formData) => {
  return (
    await apiClient.put(`/top-universities/${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
  ).data;
};

// DELETE
export const deleteTopUniversity = async (id) => {
  return (await apiClient.delete(`/top-universities/${id}`)).data;
};

// TOGGLE
export const toggleTopUniversityActive = async (id) => {
  return (await apiClient.put(`/top-universities/${id}/toggle`)).data;
};

// REORDER
export const reorderTopUniversities = async (orderData) => {
  return (
    await apiClient.put("/top-universities/reorder", { order: orderData })
  ).data;
};

/* ======================================================
   ADMIN — QUICK LINKS
====================================================== */

export const getQuickLinksAdmin = async () => {
  return (await apiClient.get("/admin/quick-links")).data.data;
};

export const updateQuickLinksAdmin = async (linksData) => {
  return (await apiClient.put("/admin/quick-links", linksData)).data;
};

/* ======================================================
   EXPORT DEFAULT
====================================================== */

export default {
  // PUBLIC
  getTopUniversities,
  getQuickLinksPublic,

  // ADMIN — TOP UNIVERSITIES
  getAllTopUniversitiesAdmin,
  createTopUniversity,
  updateTopUniversity,
  deleteTopUniversity,
  toggleTopUniversityActive,
  reorderTopUniversities,

  // ADMIN — QUICK LINKS
  getQuickLinksAdmin,
  updateQuickLinksAdmin,
};
